import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import cx from 'clsx';

import { Snackbar } from './Snackbar';
import { useSnackbarContext } from './context';
import type { ContainerProps } from './types';

export function SnackbarContainer({
  portalTargetSelecter,
  className,
  closeInMilliseconds = 3200,
  style,
  ...props
}: ContainerProps) {
  const { snackbar } = useSnackbarContext();

  const portalTarget = useMemo(() => {
    return typeof window !== 'undefined'
      ? (portalTargetSelecter &&
          document.querySelector(portalTargetSelecter)) ||
          document.body
      : null;
  }, [portalTargetSelecter]) as Element;

  if (!portalTarget || !snackbar) return null;

  return createPortal(
    <div
      role="presentation"
      className={cx('fixed z-[100] w-full', className)}
      style={style}
      {...props}
    >
      <Snackbar
        key={snackbar.id}
        {...snackbar}
        closeInMilliseconds={closeInMilliseconds}
      />
    </div>,
    portalTarget,
  );
}
